
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Payment(props) {
    const path = ['M27 6H5C3.3 6 2 7.3 2 9v14c0 1.7 1.3 3 3 ',
        '3h22c1.7 0 3-1.3 3-3V9c0-1.7-1.3-3-3-3zM5 8h22c.6 0 1 .4 1 ',
        '1v2H4V9c0-.6.4-1 1-1zm22 16H5c-.6 0-1-.4-1-1V13h24v10c0 .6-.4 1-1 1zm-12-4c0 ',
        '.6-.4 1-1 1H7c-.6 0-1-.4-1-1s.4-1 1-1h7c.6 0 1 .4 1 1z'
    ].join('');

    return (
        <SvgIcon {...props}>
            <path d={path} />
        </SvgIcon>
    );
}

Payment.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Payment;
